import { render, staticRenderFns } from "./man.vue?vue&type=template&id=35d52e98&scoped=true&"
import script from "./man.vue?vue&type=script&lang=js&"
export * from "./man.vue?vue&type=script&lang=js&"
import style0 from "./man.vue?vue&type=style&index=0&id=35d52e98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d52e98",
  null
  
)

export default component.exports